import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Link,
  FormControl,
  FormHelperText
} from '@mui/material';
import { register } from '../api';
import { useLang } from '../i18n';
import LangSwitch from '../components/LangSwitch';

function Register() {
  const { lang, t } = useLang();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [name, setName] = useState('');


  const validateForm = () => {
    const newErrors = {};

    if (!email) {
      newErrors.email = t('auth.emailRequired');
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = t('auth.emailInvalid');
    }

    if (!password) {
      newErrors.password = t('auth.passwordRequired');
    } else if (password.length < 6) {
      newErrors.password = t('auth.passwordShort');
    }

    if (password !== confirmPassword) {
      newErrors.confirmPassword = t('auth.passwordMismatch');
    }

    if (!name) {
      newErrors.name = t('auth.nameRequired');
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      // язык интерфейса, выбранный при регистрации: итальянец сразу получит курс русского
      await register(email, password, name, lang);
      navigate('/wait-email-confirmation', {
        state: { email: email, name: name } // Явно передаем email в state
      });
    } catch (err) {
      setErrors({
        ...errors,
        form: err.response?.data?.detail || t('auth.registerError')
      });
    }
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 4,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: 'background.paper'
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3 }}>
          {t('auth.registerTitle')}
        </Typography>
        <LangSwitch />

        {errors.form && (
          <Typography color="error" sx={{ mb: 2 }}>
            {errors.form}
          </Typography>
        )}

        <Box
          component="form"
          onSubmit={handleRegister}
          sx={{ width: '100%' }}
        >
          <FormControl fullWidth margin="normal" error={!!errors.email}>
            <TextField
              label={t('auth.email')}
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!errors.email}
            />
            {errors.email && <FormHelperText>{errors.email}</FormHelperText>}
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.name}>
            <TextField
              label={t('auth.name')}
              variant="outlined"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              error={!!errors.name}
            />
            {errors.name && <FormHelperText>{errors.name}</FormHelperText>}
          </FormControl>


          <FormControl fullWidth margin="normal" error={!!errors.password}>
            <TextField
              label={t('auth.password')}
              type="password"
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={!!errors.password}
            />
            {errors.password && <FormHelperText>{errors.password}</FormHelperText>}
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.confirmPassword}>
            <TextField
              label={t('auth.confirmPassword')}
              type="password"
              variant="outlined"
              fullWidth
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={!!errors.confirmPassword}
            />
            {errors.confirmPassword && <FormHelperText>{errors.confirmPassword}</FormHelperText>}
          </FormControl>

          <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1 }}>
            {t('auth.agree')}{' '}
            <Link component={RouterLink} to="/terms-of-service">{t('auth.terms')}</Link>.
          </Typography>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            sx={{ mt: 3, mb: 2 }}
          >
            {t('auth.registerButton')}
          </Button>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Link href="/login" variant="body2">
              {t('auth.haveAccount')}
            </Link>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}

export default Register;
